import React from "react";

import {
    Input,
    Row, Col, Button 
} from "reactstrap";

import _ from 'underscore';
import GoogleDrive from '../../common/GoogleDrive';
import ImageControl from '../FormParts/ImageControl'

export default class Images extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            image_items: [],
            selectable: this.props.selectable ? true : false,
            value: this.props.defaultCheckedImage ? this.props.defaultCheckedImage : ""
        };

        this.addImage = this.addImage.bind(this);
        this.removeImage = this.removeImage.bind(this)
        this.changeCallback = this.changeCallback.bind(this)
        this.handle_change_radio = this.handle_change_radio.bind(this)
    }

    handle_change_radio(e) {
        if (!this.state.selectable)
            return;
        let value = e.target.value;
        let checked = e.target.checked;

        checked && this.setState({
            value: value
        }, ()=>this.changeCallback());
    }

    componentDidUpdate(prevProps) {
        let cursign = this.props.image_items ? JSON.stringify(_.uniq(this.props.image_items)) : '';
        let prevsign = prevProps.image_items ? JSON.stringify(_.uniq(prevProps.image_items)) : '';
        if (cursign === prevsign) {
            return;
        }

        this.setState({
            image_items: this.props.image_items,
            value: this.props.defaultCheckedImage ? this.props.defaultCheckedImage : ""
        });
    }

    addImage(fileId, imageFolderId) {
        if ( this.state.image_items.length == 0 ) {
            this.setState({
                value:fileId
            });
        }
        this.setState({
            image_items:[
                ...this.state.image_items,
                fileId,
            ],
        }, ()=>this.changeCallback(imageFolderId))
    }

    changeCallback(imageFolderId=this.props.imageFolderId){
        const valueExist = this.state.image_items.findIndex(img=>img==this.state.value)
        this.props.uploadCallback(this.state.image_items, imageFolderId, valueExist===-1?"":this.state.value)
    }

    removeImage(targetIndex){
        this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
            // 画像が一つの場合は、選択状態にする
            if ( this.state.image_items.length == 2 ) {
                var items = this.state.image_items.filter((item, index)=>{
                    return targetIndex!=index;
                });
                this.setState({
                    value: items[0]
                });
            }

            this.setState({
                image_items: this.state.image_items.filter((item,index)=>targetIndex!=index)
            }, ()=>this.changeCallback())
        })
    }

    render() {
        const images = this.state.image_items.map((img, index) => {
            return (
                <Col md="6" key={"image_" + index} style={{padding:"15px"}}>
                    <div>
                        {this.props.editable && this.state.selectable && <>
                            <label>写真選択<Input type="radio" name="img_radio" value={img} checked={this.state.value == img} onChange={this.handle_change_radio} /></label>
                            <Button className="btn-sm" onClick={()=>this.removeImage(index)}>削除</Button>
                        </>}
                        <a target="_blank" href={GoogleDrive.file_url(img)} style={{display:"block", position:"relative", marginTop:"60px"}}>
                            <div style={{padding: "10%", width:"100%", minHeight:"50px", backgroundColor:"rgba(245, 246, 250, .5)", position:"absolute"}}>
                                <div style={{
                                    width:"40px",
                                    height:"40px",
                                    margin:"0 auto",
                                    border:"4px solid #e7f4f9",
                                    borderRadius: "50%",
                                    borderRightColor: "#344675",
                                    animation:"customeLoadSpin 1.4s infinite linear"
                                }}></div>
                            </div>
                            <img key={"image_" + img} onLoad={function(e){
                                    e.target.style.opacity=1
                                    e.target.previousSibling.style.display="none"
                                }} src={GoogleDrive.file_url(img)} alt='' style={{ opacity:0, objectFit: "contain", padding:"5px", width:"100%" }} className="rounded mx-auto d-block" />
                        </a>
                    </div>
                </Col>
            );
        });
        return (
            <div>
                {this.props.editable&&<Row>
                    <Col>
                        <ImageControl 
                            uploadCallback={({file, id, imageFolderId})=>{
                                this.addImage(id, imageFolderId)
                            }}
                            imageFolderId={this.props.imageFolderId}
                            gcs_path={this.props.gcs_path}
                            cropData={this.props.cropData}
                        />
                    </Col>
                </Row>}
                <Row  className="imageComponent" style={{ width: "100%", height: "250px", overflowX: "hidden", overflowY: "scroll" }}>
                    {images}
                </Row>
            </div>
        );
    }
}
